var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label label-primary"},[_vm._v(_vm._s(_vm.filecount))])
}
var staticRenderFns = []

export { render, staticRenderFns }